import { lazy } from 'react';

const WaitlistSection = lazy(() => import('../WaitlistSection'));

const WaitlistSectionLazy = () => {
  return <WaitlistSection />;
};

export default WaitlistSectionLazy; 